import Logo from "../assets/logo1.png";

function Navbar() {
  return (
    <nav className="navbar">

      <div className="logo">
        <img
          src={Logo}
          alt="Tiny Toes Preschool"
          className="logo-img"
        />
      </div>

      <div className="links">
        <a href="#about">About</a>
        <a href="#programs">Programs</a>
        <a href="#gallery">Gallery</a>
        <a href="#faq">FAQ</a>
        <a href="#contact">Contact</a>
      </div>

    </nav>
  );
}

export default Navbar;